/*
 * 模块
 * */
import types from "../types.js";
import { getRedBagStatus } from "@/api/hongbao/hongbaoh5.js";
import Api from "@/static/js/api.js"

//定义属性（数据）
var state = {
  user: { id: 0 }, //用户id
  tabbarconfig: {}, //侧边导航路由
  exclusiveWithdrawal: true, // 显示 专属红包 主播提现入口
  exclusiveKefu: {
    // checkShow:false,// 私域开关
    exclusive_lead_index_switch: false, // 首页
    exclusive_lead_withdraw_switch: false, // 提现
    exclusive_lead_switch: false, // 专属
    exclusive_lead_official_switch: false // 快手公众号引流
  }, // 私域客服对象
  isShowLuckAnimailend: false, //是否存在幸运抽奖动画
  receiveBenefitsNum: 0, // 打开福利官页面次数
  boxChannel: {}, // 当前渠道配置
  ifUnclaimedRedenvelope: {
    divideUp: false, //红包瓜分
    levelHongbao: false, //等级红包
    HongbaoTop: false //高级红包
  } //红包是否领取信息
};
//定义getters，用来获取属性
var getters = {
  userData(state) {
    console.log(state.user);
    return state.user;
  },
  tabbarConfig() {
    return state.tabbarconfig;
  },
  ReceiveBenefitsNum() {
    return state.receiveBenefitsNum;
  },
  showAnchorExclusiveWithdrawal() {
    return state.exclusiveWithdrawal;
  },
  exclusiveKefuData() {
    return state.exclusiveKefu;
  },
  /** 获取 -/box/channe- 渠道配置 */
  Stror_Get_BoxChannel(state) {
    return state.boxChannel;
  },
  /** 获取是否存在未领取红包数据 */
  ifUnclaimedRedenvelopeData(state) {
    return state.ifUnclaimedRedenvelope;
  }
};
//定义mutations，处理状态（数据）的改变
const mutations = {
  /** 设置渠道配置 */
  SET_User_boxChannel(state, val) {
    state.boxChannel = val;
  },
  // 设置福利官页面次数
  SET_receiveBenefitsNum_Fn(state, num) {
    localStorage.setItem("ReceiveBenefitsNumStro", num);
    state.receiveBenefitsNum = num;
  },
  SET_ExclusiveWithdrawal(state, data) {
    // 设置 专属红包 主播提现入口
    state.exclusiveWithdrawal = data;
  },
  SET_exclusiveKefu(state, data) {
    // 设置私域客服数据
    state.exclusiveKefu = data;
  },
  [types.GET_USER](state, data) {
    // 如果是location写死token v5
    if (window.location.hostname == "localhost") {
      // data.token = "11eeeca7d1ef36f6b0d800163e2c8a83";
      // data.token = "11ed7396c1505086bd8f00163e06b6ba"; // 正式
      data.token = "11f0ae4de0eece32bcef00163e01a290" // 测试
      // data.token = "11edc22de7d23b44aef800163e2c8a83";
      // data.token = "11eddb807890bf5a831e00163e16fe28"
      // data.token = "11ed81a82988a54e80ee00163e2c8a83"
    }

    state.user = data;
    sessionStorage.setItem("wz_user_data", JSON.stringify(data));
  },
  [types.REMOVE_USER](state) {
    sessionStorage.removeItem("wz_user_data");
    state.user = { id: 0 };
  },
  [types.SET_USER](state, data) {
    state.user = data;
  },
  // 设置侧边栏的tab的数据
  [types.GET_TABBAR_CONFIG](state, data) {
    console.log(data, "GET_TABBAR_CONFIG");
    state.tabbarconfig = data;
    sessionStorage.setItem("channel_tabbar_config", JSON.stringify(data));
  },
  [types.REMOVE_TABBAR_CONFIG](state) {
    sessionStorage.removeItem("channel_tabbar_config");
    state.tabbarconfig = {};
  },
  [types.SET_TABBAR_CONFIG](state, data) {
    state.tabbarconfig = data;
  },
  setisShowLuckAnimailend(state, data) {
    state.isShowLuckAnimailend = data;
  },
  setIfUnclaimedRedenvelope(state, data) {
    state.ifUnclaimedRedenvelope = data;
  }
};
//定义actions，要执行的操作，如流程判断、异步请求等
const actions = {
  getUser({ commit }, data) {
    if (data && typeof data === "object") {
      commit(types.GET_USER, data);
    } else if (sessionStorage.getItem("wz_user_data") != null) {
      let data = sessionStorage.getItem("wz_user_data");
      commit(types.GET_USER, JSON.parse(data));
    } else {
      console.log("getUser：no data");
    }
    console.log("getUser  00 ：", data);
  },
  getTabbarConfig({ commit }, data) {
    if (data && typeof data === "object") {
      commit(types.GET_TABBAR_CONFIG, data);
    } else if (sessionStorage.getItem("channel_tabbar_config") != null) {
      let data = sessionStorage.getItem("channel_tabbar_config");
      commit(types.GET_TABBAR_CONFIG, JSON.parse(data));
    } else {
      console.log("getTabbarConfig：no data");
    }
  },
  removeUser({ commit }) {
    commit(types.REMOVE_USER);
  },
  removeTabbarConfig({ commit }) {
    commit(types.REMOVE_TABBAR_CONFIG);
  },
  // 获取红包领取状态
  getIfUnclaimedRedenvelope({ commit, getters },Info) {
    let params={
      version:Api.config.app_version
    }
    let headers
    if(Info&&Info.token){
      headers={
        token:Info.token
      }
    }
    if(Info&&Info.appid){
      params.game_id=Info.appid
      params.channel=Info.channel
    }else{
      params.game_id=getters.userData.appid
      params.channel=getters.userData.channel
    }
    getRedBagStatus(params,headers).then(res => {
      if (res.data.code !== 200) {
        return;
      }
      let statusInfo = {
        divideUp: false, //红包瓜分
        levelHongbao: false, //等级红包
        HongbaoTop: false //高级红包
      };
      const datas = res.data.data;
      var game_menu = getters.tabbarConfig.game_menu;
      //限时等级红包
      if (game_menu && game_menu.game_level_limit_income_switch == 1) {
        statusInfo.divideUp = datas.check1;
      } else if (game_menu.game_level_income == 1) {
        statusInfo.divideUp = datas.check2;
      }
      console.log(game_menu.game_level_red_bag_v2_switch,game_menu.old_game_level_red_bag_switch);
      if (game_menu.game_level_red_bag_v2_switch == 1) {
        //V2版限时红包
        statusInfo.levelHongbao = datas.check3;
      } else if (game_menu.old_game_level_red_bag_switch == 1) {
        statusInfo.levelHongbao = datas.check4;
      }
      if (game_menu.game_level_high_red_bag_v2_switch == 1) {
        //V2版限时高级红包
        statusInfo.HongbaoTop = datas.check5;
      } else if (game_menu.high_red_bag_switch == 1) {
        statusInfo.HongbaoTop = datas.check6;
      } else if (game_menu.limit_recharge_red_bag == 1) {
        statusInfo.HongbaoTop = datas.check7;
      }
      console.log(statusInfo,"datas.check3");
      commit("setIfUnclaimedRedenvelope",statusInfo);
    });
  }

  // setUser({commit},data){
  // if(sessionStorage.getItem('wz_user') != null){
  //   console.log('22222222');
  //   let userdata = JSON.parse(Base64.decode(sessionStorage.getItem('wz_user')));  //解密
  //
  //   for(let key in data){
  //     userdata[key] = data[key];
  //   }
  //   sessionStorage.setItem("wz_user", Base64.encode(JSON.stringify(userdata)));
  //   commit(types.SET_USER, userdata);
  // } else {
  //   console.log('setUser：no data');
  // }
  // }
};

//导出store对象
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js